import React from 'react';
import {Table} from 'semantic-ui-react';
import {NoData} from "../../components/table/no-data";
import FormattedDate from "../../components/formatters/formattedDate";
import Currency from "../../components/formatters/currency";

export default class ContractTradesStratsTableRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <Table.Row>
                <Table.Cell>{this.props.data.tradingStrategyTypeName || <NoData/>}</Table.Cell>
                <Table.Cell><FormattedDate value={this.props.data.periodFromDescription}/></Table.Cell>
                <Table.Cell><FormattedDate value={this.props.data.periodToDescription}/></Table.Cell>
                <Table.Cell><FormattedDate value={this.props.data.virtualCapEffectiveFromDate}/></Table.Cell>
                <Table.Cell><Currency value={this.props.data.virtualCapInitialCost}/></Table.Cell>
            </Table.Row>
        );
    }
}